export const Environment = {
  BASE_API: process.env.REACT_APP_BASE_API,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  RE_CAPCHA_SITE_KEY: process.env.REACT_APP_RE_CAPCHA_SITE_KEY || "",
  FACEBOOK_PAGE:
    process.env.REACT_APP_FACEBOOK_PAGE_LINK ||
    "https://www.facebook.com/pcrenderrdp",
  DISCORD_PAGE:
    process.env.REACT_APP_DISCORD_PAGE_LINK || "https://discord.gg/rBbqTrBD9w",
};
